import React from 'react';
import { Link } from 'react-router-dom';
import ProjectList from '../../components/ProjectList';

const Projects = ({ t, projectsData }) => {
  return (
    <section className="projects">
      <div className="projects__header">
        <h2 className="h2">{t.title}</h2>
        <Link className="projects__link" to="/projects">{t.button} ~~></Link>
      </div>
      <ProjectList limit={3} t={projectsData} />
    </section>
  );
};

export default Projects;
